import React, { FC } from 'react';

import styles from './CharacterLimitStyles.scss';

const CharacterLimit: FC<{ limit: number; textLength?: number }> = ({ limit, textLength = 0 }) => {
  return (
    <div className={styles.textLimit}>
      Max character count: {limit} (Characters remaning:{' '}
      {textLength <= limit ? (
        limit - textLength
      ) : (
        <span className={styles.overLimit}>{limit - textLength}</span>
      )}
      )
    </div>
  );
};

export default CharacterLimit;
